import { useEffect, useRef, useState } from "react";
import { ArmenianFlag, RussianFlag, UnitedStatesFlag } from "../../Assets/Icons";
import { useTranslation } from "react-i18next";

const useLanguagesHooks = () => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language;

  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node) ) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const currentLanguageData = languages.find((item) => item.code === activeLanguage);
    if (currentLanguageData) {
      setActiveLangSrc(currentLanguageData.icon);
    }
  }, [activeLanguage]);

  const languages = [
    {
      id: 0,
      icon: ArmenianFlag,
      code: "hy",
    },
    {
      id: 1,
      icon: RussianFlag,
      code: "ru",
    },
    {
      id: 2,
      icon: UnitedStatesFlag,
      code: "en",
    },
  ];
 const activLanguageData = languages.filter((item)=>item.code === activeLanguage)[0];
  const [show, setShow] = useState<boolean>(false);
  const [activeLangSrc, setActiveLangSrc] = useState<string>(
    activLanguageData?.icon || ArmenianFlag
  );
  const checkableLanguages = languages.filter(
    (item) => item.icon !== activeLangSrc
  );


  const changeActiveLanguage = (active: string) => {
    i18n.changeLanguage(active);
    localStorage.setItem('p_m_language', active)
  };

  return {
    t,
    containerRef,
    activeLanguage,
    activeLangSrc,
    checkableLanguages,
    setAnchor,
    setActiveLangSrc,
    changeActiveLanguage,
  };
};

export default useLanguagesHooks;
